import {TeamPreferencesModel} from '../../../models/api/teamPreferencesModel';
import {AppAction} from '../../appActions';
import {TeamPreferencesActionsEnum} from './teamPreferencesActions';

export function teamPreferencesReducer(state: TeamPreferencesModel, action: AppAction): TeamPreferencesModel {
  switch (action.type) {
    case TeamPreferencesActionsEnum.TEAM_BUSINESS_HOURS_PREFERENCES_UPDATED: {
      return {
        ...state,
        businessHours: {
          ...state.businessHours,
          ...action.payload.businessHours,
        },
      };
    }

    case TeamPreferencesActionsEnum.TEAM_BUSINESS_HOURS_PREFERENCES_UPDATE_FAILED: {
      return {
        ...state,
        businessHours: {
          ...state.businessHours,
          hasUpdateError: true,
        },
      };
    }

    case TeamPreferencesActionsEnum.TEAM_BUSINESS_HOURS_PREFERENCES_RESET_ERROR: {
      return {
        ...state,
        businessHours: {
          ...state.businessHours,
          hasUpdateError: false,
        },
      };
    }

    default:
      return state;
  }
}
